const ua = window.navigator.userAgent;
const isIE = /MSIE|Trident/.test(ua);
const isEDGE = /Edge/.test(ua);

// ignore for IE
if (isIE) {
  $('body').addClass('ie11');

  $.fn.patchImageAspectRatio = function () {
    this.each(function () {
      let image = '';
      let srcset = $(this).find('source[data-view=xl]').first().attr('srcset');

      if (srcset) {
        /** process typo3 pictures */
        let separator_index = srcset.indexOf(', ');

        if (separator_index > 0) {
          image = srcset.substring(0, separator_index);
        } else {
          image = srcset;
        }
      } else {
        /** process api pictures */
        image = $(this).find('img').first().attr('src');
      }

      $(this).css('background-image', 'url(' + image + ')');
    });
    return this;
  };

  $.fn.patchFlexboxIntrinsicHeight = function () {
    this.each(function () {
      let img = $(this).find('img').first();
      let height = img.height();
      $(this).css('height', height + 'px');

      if (img.hasClass('m-career-teas__visual--news-image')) {
        $(this).css({
          'background-image': 'url(' + img.attr('src') + ')',
          'background-position': 'center',
          'background-size': 'cover'
        });
        img.css('display', 'none');
      }
    });

    return this;
  };

  /*Bugfix: Teasers & Heroes aspect ratio*/
  $('.m-news-teas__cover, .m-career-teas__cover, .m-cat-box__cover, .m-hero-slide__visual').patchImageAspectRatio();

  /*Bugfix: Flexbox intrisic height*/
  $('.m-news-teas__visual, .m-career-teas__visual, .m-cat-box__visual, .m-person__img').patchFlexboxIntrinsicHeight();
}

if (isIE | isEDGE) {
  $('video').each(function () {
    document.getElementById($(this).attr('data-video-id')).play();
  });
}
